import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useExpenseTypeService from '../../../app/services/hooks/useExpenseTypeService';

interface Props {
    expenseTypeId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ExpenseTypeSwitchChange = ({ expenseTypeId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeExpenseType, fetchingActiveExpenseType } = useExpenseTypeService();

    const active = (value: boolean) => {
        setChecked(value);

        activeExpenseType(expenseTypeId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={expenseTypeId} callback={active} />;
};

export default ExpenseTypeSwitchChange;
